module.exports = __webpack_public_path__ + "img/12.png.32d0c781.webp";